import React, {useEffect} from 'react';

export default function Contacto() {
    useEffect(() => {
        const script = document.createElement("script");
        script.src =
            "https://formfacade.com/include/103307635053267445224/form/1FAIpQLSfc3nTY1nqCsxIhOKrz_UQsMO8YfdoloSUeR6hF9lRr1yv-Tw/classic.js?div=ff-compose"
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    
        return () => {
            document.body.removeChild(script);
        };
    }, []);
    
    return (
        <div id="contacto">
            <div className='destacado'>
                <h1>Contacto</h1>

                <p>Puedes utilizar el siguiente formulario para mandarnos un email, al que responderemos a la mayor brevedad posible.</p>
            </div>
            <div id='ff-compose'></div>
        </div>
    );
}